var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AddNewSite',{attrs:{"isCollaboration":false}})
}
var staticRenderFns = []

export { render, staticRenderFns }